export class SchedulerResourceValueObject {
  static branch = 'Branch'
  static tResourceTypeName = 'tResourceTypeName'
  static ResourceName = 'ResourceName'
  static idtUserGroup = 'idtUserGroup'
  static resourceId = 'ResourceID'
  static ResourceTable = 'ResourceTable'
  static type = 'EventsType'
  static avatar = 'Avatar'
  static skills = 'Skill'

  /**
   *
   * @param branch
   * @param resourceTypeName
   * @param resourceName
   * @param idUserGroup
   * @param resourceTable
   * @param type
   */
  constructor (
    branch,
    resourceTypeName,
    resourceName,
    idUserGroup,
    resourceTable,
    type,
    avatar,
    skills
  ) {
    this._branch = branch
    this._resourceTypeName = resourceTypeName
    this._resourceName = resourceName
    this._idUserGroup = idUserGroup
    this._resourceTable = resourceTable
    this._type = type
    this._avatar = avatar
    this._skills = skills
  }

  get fontColor () {
    if (this.resourceTable === 'tUser2') {
      return '#C0C0C0'
    }

    return '#000000'
  }

  get idUserGroup () {
    return this._idUserGroup
  }

  set idUserGroup (value) {
    this._idUserGroup = value
  }

  get resourceName () {
    return this._resourceName
  }

  set resourceName (value) {
    this._resourceName = value
  }

  get branch () {
    return this._branch
  }

  set branch (value) {
    this._branch = value
  }

  get resourceTypeName () {
    return this._resourceTypeName
  }

  set resourceTypeName (value) {
    this._resourceTypeName = value
  }

  get branchColor () {
    return '#FFDA8F'
  }

  get branchNameColor () {
    if (this.resourceTable === 'tResource') {
      return '#8484FF99'
    }

    if (this.resourceTable === 'tUserGroup') {
      return '#FF848499'
    }

    if (this.resourceTable === 'tUser2') {
      return '#00000066'
    }

    return '#1F89ED99'
  }

  get userGroupNameColor () {
    if (this.resourceTable === 'tResource') {
      return '#8484FF1A'
    }

    if (this.resourceTable === 'tUserGroup') {
      return '#FF84841A'
    }

    if (this.resourceTable === 'tUser2') {
      return 'repeating-linear-gradient(' +
        '-45deg,' +
        '#c2e4ff4d,' +
        '#c2e4ff4d 5px,' +
        '#c2e4ff4d 5px,' +
        '#c2e4ff00 10px' +
      ')'
    }

    return '#1F89ED40'
  }

  get resourceTable () {
    return this._resourceTable
  }

  get type () {
    return this._type
  }

  get avatar () {
    return this._avatar
  }

  get skills () {
    return this._skills
  }

  /**
   *
   * @param apiObject
   * @returns {SchedulerResourceValueObject}
   */
  static fromApiObject (apiObject) {
    return new SchedulerResourceValueObject(
      apiObject[SchedulerResourceValueObject.branch],
      apiObject[SchedulerResourceValueObject.tResourceTypeName],
      apiObject[SchedulerResourceValueObject.ResourceName],
      apiObject.hasOwnProperty(SchedulerResourceValueObject.idtUserGroup)
        ? apiObject[SchedulerResourceValueObject.idtUserGroup]
        : apiObject[SchedulerResourceValueObject.resourceId],
      apiObject[SchedulerResourceValueObject.ResourceTable],
      apiObject[SchedulerResourceValueObject.type],
      JSON.parse(apiObject[SchedulerResourceValueObject.avatar] || null),
      JSON.parse(apiObject[SchedulerResourceValueObject.skills] || null)
    )
  }

  /**
   *
   * @returns {{tResourceTypeName: *, ResourceName: *, idtUserGroup: *}}
   */
  toApiObject () {
    const output = {}

    output[SchedulerResourceValueObject.branch] = this.branch
    output[SchedulerResourceValueObject.tResourceTypeName] = this.resourceTypeName
    output[SchedulerResourceValueObject.ResourceName] = this.resourceName
    output[SchedulerResourceValueObject.resourceId] = this.resourceName
    output[SchedulerResourceValueObject.idtUserGroup] = this.idUserGroup

    return output
  }
}
